import { render, staticRenderFns } from "./jieshao1.vue?vue&type=template&id=4e2d607c&scoped=true&"
import script from "./jieshao1.vue?vue&type=script&lang=js&"
export * from "./jieshao1.vue?vue&type=script&lang=js&"
import style0 from "./jieshao1.vue?vue&type=style&index=0&id=4e2d607c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d607c",
  null
  
)

export default component.exports